module.exports = __webpack_public_path__ + "static/img/preliminary-round-no6.942fc0ae.png";